module.exports = __webpack_public_path__ + "static/needle_lord-8027edcdeae3fb7f1b18628ea585939a.jpeg";